import { Loader2 } from "lucide-react"

export const MainLoader = () => {
  return (
    <div className="tw:flex tw:h-screen tw:items-center tw:justify-center">
      <Loader2 className="tw:size-6 tw:animate-spin" />
    </div>
  )
}
